import { useState } from 'react'
import Image from "next/image"
import useSWR from 'swr'
import Loading from "../loading"
import Modal from "../modal"
import Related from "../related"

export default function PortfolioShow({ title, subTitle, children, folderPath, mainPhotoUrl, photoAlt }) {

  const [isOpen, setIsOpen] = useState({ isOpen: false, picNum: 0 })
  const fetcher = (url) => fetch(url).then((res) => res.json())
  const { data } = useSWR(`/api/readfiles?path=${folderPath}`, fetcher)

  const Gallery = () => {
    if (!data) {
      return (
        <div className="p-4 flex flex-col items-center justify-center">
          <Loading />
          <p className="p-2 text-almost-white font-lato uppercase text-sm">A carregar as fotos</p>
        </div>
      )
    }
    return (
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {data.map((fotoPath, idx) => {
          return (
            //<div key={idx} className="relative h-[50vh] shadow-lg shadow-black">
            <Image
              key={idx}
              src={fotoPath}
              alt={photoAlt}
              width={760}
              height={625}
              objectFit="cover"
              quality={100}
              className="cursor-pointer shadow-lg shadow-black"
              onClick={() => setIsOpen({ isOpen: true, picNum: idx })}
            />
            //</div>
          )
        })}
      </div>
    )
  }

  return (
    <>
      <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2 items-center mb-28 lg:mb-[200px]">
        <div className="relative mb-5 h-[50vh] shadow-lg shadow-black">
          <Image
            src={mainPhotoUrl}
            alt={photoAlt}
            layout="fill"
            objectFit="cover"
            quality={100}
            priority
          />
        </div>
        <div className="px-4 lg:px-0 lg:pl-10">
          <h1 className="font-josefin-sans text-white text-4xl">{title}</h1>
          <p className="font-lato text-almost-white text-lg">{subTitle}</p>
        </div>
      </div>
      <div className="container mx-auto text-white px-4 lg:px-0 font-lato mb-28 lg:mb-[200px]">
        {children}
      </div>
      <div className="container mx-auto mb-28">
        {Gallery()}
      </div>
      <div className="container mx-auto  mb-8 lg:mb-20">
        <Related
          title={title}
        />
      </div>
      <Modal isOpenObj={isOpen} setIsOpen={(isModalOpen) => setIsOpen(isModalOpen)} photoAlt={photoAlt} data={data} />
    </>
  )
}